import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const deviceSetUpHeading = Loadable(() => import('../../containers/web/deviceSetUpHeading'));
export default MapTo('vcg/components/soe-home/react/deviceSetUpHeading')(deviceSetUpHeading);
